export default __webpack_public_path__ + "static/media/question_08.ebe071d7.png";